import { yesNoOptions } from "library/sharedOptions";

export const getOptionLabel =
  (options) =>
  (value: string): string => {
    const option = options.find((opt) => opt.value === value);

    return option === undefined ? "" : option.label;
  };

export const getYesNoLabel = getOptionLabel(yesNoOptions);

export const relationshipStatusOptions = [
  {
    label: "Single/other",
    value: "SINGLE",
  },
  {
    label: "Married/Defacto",
    value: "MARRIED",
  },
] as const;

export const nzRelationshipStatusOptions = [
  { label: "Defacto", value: "relationship_defacto" },
  { label: "Divorced", value: "relationship_divorced" },
  { label: "Married", value: "relationship_married" },
  { label: "Separated", value: "relationship_separated" },
  { label: "Single", value: "relationship_single" },
  { label: "Widowed", value: "relationship_widowed" },
] as const;

export const getRelationshipStatusLabel = getOptionLabel(
  relationshipStatusOptions,
);

export const residentialStatusOptions = [
  { label: "I live with my parents", value: "LIVE_IN" },
  { label: "I'm boarding", value: "BOARDING" },
  { label: "I'm renting", value: "RENTING" },
  { label: "I own my own home with a mortgage", value: "MORTGAGE" },
  {
    label: "I own my own home without a mortgage",
    value: "NO_MORTGAGE",
  },
] as const;

export const frequencyOptions = [
  { label: "Weekly", value: "weekly" },
  { label: "Fortnightly", value: "fortnightly" },
  { label: "Monthly", value: "monthly" },
] as const;

export const communicationMethodOptions = [
  { label: "email", value: "email_method" },
  { label: "phone", value: "phone" },
] as const;

export const getResidentialStatusLabel = getOptionLabel(
  residentialStatusOptions,
);

export const employmentStatusOptions = [
  { label: "Permanent full time", value: "FULL_TIME" },
  { label: "Permanent part time", value: "PART_TIME" },
  { label: "Casual/Seasonal/Temporary", value: "CASUAL" },
  { label: "Contractor full time", value: "CONTRACTOR_FULL_TIME" },
  { label: "Contractor part time", value: "CONTRACTOR_PART_TIME" },
  { label: "Self-employed", value: "SELF_EMPLOYED" },
  {
    label: "Workers compensation/Social security",
    value: "COMP",
  },
  { label: "Other", value: "OTHER" },
] as const;
export const getEmploymentStatusLabel = getOptionLabel(employmentStatusOptions);

export const occupationOptions = [
  { label: "Advertising", value: "ADVERTISING" },
  { label: "Agriculture/Forestry/Horticulture", value: "AGRICULTURE" },
  { label: "Armed Services", value: "ARMED_SERVICES" },
  { label: "Banking/Finance", value: "BANKING" },
  { label: "Civil Service", value: "CIVIL_SERVICE" },
  { label: "Cleaning/Laundry", value: "CLEANING" },
  { label: "Construction", value: "CONSTRUCTION" },
  { label: "Education", value: "EDUCATION" },
  { label: "Emergency Services", value: "EMERGENCY_SERVICES" },
  { label: "Home Duties", value: "HOME_DUTIES" },
  { label: "Hospital", value: "HOSPITAL" },
  { label: "Hotel", value: "HOTEL" },
  { label: "Industry Services", value: "INDUSTRY_SERVICES" },
  { label: "Information Technology", value: "IT" },
  { label: "Insurance", value: "INSURANCE" },
  { label: "Manufacturing", value: "MANUFACTURING" },
  { label: "Media", value: "MEDIA" },
  { label: "Mining", value: "MINING" },
  { label: "Other Category", value: "OTHER" },
  { label: "Pensioner", value: "PENSIONER" },
  { label: "Personal/Leisure/Entertainment", value: "PERSONAL_LEISURE" },
  { label: "Property/Business", value: "PROPERTY" },
  { label: "Restaurant", value: "RESTAURANT" },
  { label: "Retail/Wholesale", value: "RETAIL" },
  { label: "Retired", value: "RETIRED" },
  { label: "Sciences", value: "SCIENCES" },
  { label: "Student", value: "STUDENT" },
  { label: "Transport", value: "TRANSPORT" },
  { label: "Unemployed", value: "UNEMPLOYED" },
] as const;
export const getOccupationLabel = getOptionLabel(occupationOptions);
